// import React, { useEffect, useState, useCallback } from 'react'

// import axios from 'axios'
// import AddButton from './AddModel'
// import CustomTable from 'screens/CustomTable/CustomTable'
// import CustomTableColumns from './QuestionBankColumns'
// import { useStoreon } from 'storeon/react'

// const QuestionBank = () => {
// 	const [tableData, setTableData] = useState([])
// 	const [loading, setLoading] = useState(true)
// 	const { token } = useStoreon('token')
// 	// const fetchData = useCallback(async () => {
// 	// 	setLoading(true)
// 	// 	try {
// 	// 		const response = await axios.get(
// 	// 			`${process.env.REACT_APP_API_URL}/api/v1/custom/getAllQuestions`,
// 	// 			{
// 	// 				headers: {
// 	// 					Authorization: ` ${token}`
// 	// 				}
// 	// 			}
// 	// 		)

// 	// 		const userQuestions = response.data?.userQuestions || []

// 	// 		const flatQuestions = userQuestions.flatMap((section: any) => {
// 	// 			return (section.questions || []).map((q: any) => {
// 	// 				console.log(
// 	// 					'Section:',
// 	// 					section.sectionName,
// 	// 					'Subsection:',
// 	// 					section.subSectionName
// 	// 				)

// 	// 				return {
// 	// 					...q,
// 	// 					name: section.name,
// 	// 					sectionName: section.sectionName,
// 	// 					subSectionName: section.subSectionName,
// 	// 					parentId: section._id,
// 	// 					createdBy: section.createdBy,
// 	// 					createdAt: section.createdAt,
// 	// 					updatedAt: section.updatedAt
// 	// 				}
// 	// 			})
// 	// 		})

// 	// 		setTableData(flatQuestions)
// 	// 	} catch (error) {
// 	// 		console.error('Error fetching data:', error)
// 	// 	} finally {
// 	// 		setLoading(false)
// 	// 	}
// 	// }, [])
// 	const fetchData = useCallback(async () => {
// 		setLoading(true)
// 		try {
// 			const offset = '1-100'

// 			const response = await axios.get(
// 				`${process.env.REACT_APP_API_URL}/api/v1/custom/getAllQuestions`,
// 				{
// 					params: {
// 						offset
// 					},
// 					headers: {
// 						Authorization: ` ${token}`
// 					}
// 				}
// 			)

// 			const userQuestions = response.data?.userQuestions || []

// 			const flatQuestions = userQuestions.flatMap((section: any) => {
// 				return (section.questions || []).map((q: any) => {
// 					console.log(
// 						'Section:',
// 						section.sectionName,
// 						'Subsection:',
// 						section.subSectionName
// 					)

// 					return {
// 						...q,
// 						name: section.name,
// 						sectionName: section.sectionName,
// 						subSectionName: section.subSectionName,
// 						parentId: section._id,
// 						createdBy: section.createdBy,
// 						createdAt: section.createdAt,
// 						updatedAt: section.updatedAt
// 					}
// 				})
// 			})

// 			setTableData(flatQuestions)
// 		} catch (error) {
// 			console.error('Error fetching data:', error)
// 		} finally {
// 			setLoading(false)
// 		}
// 	}, [])

// 	useEffect(() => {
// 		fetchData()
// 	}, [fetchData])
// 	console.log('chandu', tableData)

// 	return (
// 		<div style={{ display: 'flex', flexDirection: 'column' }}>
// 			<div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
// 				<AddButton refreshData={fetchData} />
// 			</div>

// 			<CustomTable
// 				tableColumns={CustomTableColumns(fetchData)}
// 				tableData={tableData}
// 				loading={loading}
// 				noDataMessage="No questions available"
// 			/>
// 		</div>
// 	)
// }

// export default QuestionBank

// import React, { useEffect, useState, useCallback } from 'react'

// import axios from 'axios'
// import AddButton from './AddModel'
// import CustomTable from 'screens/CustomTable/CustomTable'
// import CustomTableColumns from './QuestionBankColumns'
// import { useStoreon } from 'storeon/react'

// const QuestionBank = () => {
// 	const [tableData, setTableData] = useState<any[]>([])

// 	const [loading, setLoading] = useState(true)
// 	const { token } = useStoreon('token')

// 	const fetchData = useCallback(async () => {
// 		setLoading(true)
// 		let allQuestions: any[] = []
// 		let currentStart = 1
// 		const batchSize = 50
// 		let totalItems = 0

// 		try {
// 			while (true) {
// 				const offset = `${currentStart}-${currentStart + batchSize - 1}`

// 				const response = await axios.get(
// 					`${process.env.REACT_APP_API_URL}/api/v1/custom/getAllQuestions`,
// 					{
// 						params: { offset },
// 						headers: { Authorization: ` ${token}` }
// 					}
// 				)

// 				const { userQuestions = [], pagination = {} } = response.data
// 				totalItems = pagination.totalItems || 0

// 				const flatQuestions = userQuestions.flatMap((section: any) =>
// 					(section.questions || []).map((q: any) => ({
// 						...q,
// 						name: section.name,
// 						sectionName: section.sectionName,
// 						subSectionName: section.subSectionName,
// 						parentId: section._id,
// 						createdBy: section.createdBy,
// 						createdAt: section.createdAt,
// 						updatedAt: section.updatedAt
// 					}))
// 				)

// 				allQuestions = [...allQuestions, ...flatQuestions]

// 				currentStart += batchSize

// 				if (allQuestions.length >= totalItems) {
// 					break
// 				}
// 			}

// 			setTableData(allQuestions)
// 		} catch (error) {
// 			console.error('Error fetching data:', error)
// 		} finally {
// 			setLoading(false)
// 		}
// 	}, [token])

// 	useEffect(() => {
// 		fetchData()
// 	}, [fetchData])

// 	return (
// 		<div style={{ display: 'flex', flexDirection: 'column' }}>
// 			<div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
// 				<AddButton refreshData={fetchData} />
// 			</div>

// 			<CustomTable
// 				tableColumns={CustomTableColumns(fetchData)}
// 				tableData={tableData}
// 				loading={loading}
// 				noDataMessage="No questions available"
// 			/>
// 		</div>
// 	)
// }

// export default QuestionBank

import React, { useEffect, useState, useCallback } from 'react'
import axios from 'axios'
import AddButton from './AddModel'
import CustomTable from 'screens/CustomTable/CustomTable'
import CustomTableColumns from './QuestionBankColumns'
import { useStoreon } from 'storeon/react'

const QuestionBank = () => {
	const [tableData, setTableData] = useState<any[]>([])
	const [loading, setLoading] = useState(true)
	const { token } = useStoreon('token')

	const fetchData = useCallback(async () => {
		setLoading(true)
		setTableData([]) // Clear previous data before loading

		let currentStart = 1
		const batchSize = 50
		let totalItems = 0

		try {
			while (true) {
				const offset = `${currentStart}-${currentStart + batchSize - 1}`

				const response = await axios.get(
					`${process.env.REACT_APP_API_URL}/api/v1/custom/getAllQuestions`,
					{
						params: { offset },
						headers: { Authorization: ` ${token}` }
					}
				)

				const { userQuestions = [], pagination = {} } = response.data
				totalItems = pagination.totalItems || 0

				const flatQuestions = userQuestions.flatMap((section: any) =>
					(section.questions || []).map((q: any) => ({
						...q,
						name: section.name,
						sectionName: section.sectionName,
						subSectionName: section.subSectionName,
						parentId: section._id,
						createdBy: section.createdBy,
						createdAt: section.createdAt,
						updatedAt: section.updatedAt
					}))
				)

				// Instead of waiting for all batches, update tableData now
				setTableData(prevData => [...prevData, ...flatQuestions])

				currentStart += batchSize

				if (currentStart > totalItems) {
					break
				}
			}
		} catch (error) {
			console.error('Error fetching data:', error)
		} finally {
			setLoading(false)
		}
	}, [token])

	useEffect(() => {
		fetchData()
	}, [fetchData])

	return (
		<div style={{ display: 'flex', flexDirection: 'column' }}>
			<div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
				<AddButton refreshData={fetchData} />
			</div>

			<CustomTable
				tableColumns={CustomTableColumns(fetchData)}
				tableData={tableData}
				loading={loading}
				noDataMessage="No questions available"
			/>
		</div>
	)
}

export default QuestionBank
